var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"copy-id-btn",attrs:{"title":_vm.copied ? 'Copied!' : 'Copy ID'},on:{"click":function($event){$event.stopPropagation();return _vm.copyToClipboard.apply(null, arguments)}}},[_c('i',{class:_vm.copied ? 'fa fa-check text-success' : 'fa fa-copy'})])
}
var staticRenderFns = []

export { render, staticRenderFns }